const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/user-management/users/$userId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/settings/user-management/users/$userId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => {
    return {
      crumb: i18n.t('userManagement.tempoUserProfile.userProfile')
    };
  },
  staticData: {
    topNav: {
      title: i18n.t('userManagement.tempoUserProfile.userProfile')
    }
  }
});